<template>
    <div style="background:white; " class="ve-list-page">
        <div style=" background:white;line-height:30px; border-bottom:2px solid #389;height:38px"> 
            <div style="padding-top:3px;display:flex;width:1400px;line-height:30px ">
 
                <span style=" margin-left:20px;font-size:12px;margin-right:10px;">{{ $LANG('0681', '字段查询') }}</span>
                <el-select v-model="selparam" size="small" :placeholder="$LANG('1675', '请选择列名')" filterable style="width:130px;  " >
                    <span v-for="item in tabCol" :key='item.key'>
                        <el-option :label="$translate.getColTitle(item, $store.state.lang)" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="stfgChange" size="small" style="width:300px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="stfgChange" ></el-button>
                </el-input> 
                <div style=" font-weight:600;font-size:12px;margin-right:8px;margin-left:15px">库存数 > 0</div>
                <el-checkbox style="font-weight:600;font-size:12px" @change="getTabList('') "   true-label="Y" false-label="N" v-model="v_stk"></el-checkbox> 
                <el-button  @click="openFieldSettingsDialog().catch(() => {})" type="danger" plain size="small" style="height:30px;margin-top:1px;margin-left:20px;border:1px solid #f00">
                    <i class="iconfont icon-shezhi" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>{{ $LANG('0683', '字段设置')}}
                </el-button>
            </div>
        </div> 
        <div style="width:100%" class="ve-list-page__body">
            <div class="ve-list-page__table">
                <ve-table :columns="vueCol"
                    :table-data="qcData"
                    :columnHiddenOption="columnHiddenOption"
                    class="custom-table-border"
                    :border-around="true"
                    :border-x="true"
                    :border-y="true"
                    :fixed-header="true"
                    row-key-field-name="IDSEQ"
                    :row-style-option="rowStyleOption"
                    :cell-style-option="cellStyleOption"
                    :max-height="subHeight"
                    :footer-data="footerData"
                    :virtual-scroll-option="virtualScrollOption"
                    :scroll-width="0"
                    :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                    :column-width-resize-option="columnWidthResizeOption"
                    :cellSelectionOption="{enable: false}"
                    id="mat_query_one"
                    ref="refqc">
                </ve-table>
            </div>
            <!-- 分页查询 -->
            <div style="margin-top:2px" class="ve-list-page__pagination">
                <ve-pagination
                    :total="dataCount"
                    :page-index="pageIndex"
                    :page-size="pageSize"
                    :page-size-option="pageList"
                    @on-page-number-change="pageNumberChange"
                    @on-page-size-change="pageSizeChange"
                />
            </div>
        </div>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">{{ $LANG('1638', '确定') }}</el-button>
            </span>
        </el-dialog>
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="logWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">日志明细</span>
            </div> 
            <el-table :data="logData" 
                border                            
                disabled-hover
                class="custom-table-border"
                style="overflow:auto;margin-top:-5px;"
                :header-cell-style="headStyle"
                size="small"
                height="280px" 
                :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                v-loading="v_loading"
                element-loading-background = "rgba(255, 255, 255, .5)"
                element-loading-text = "加载中，请稍后..."
                element-loading-spinner = "el-icon-loading"
                highlight-current-row>
                <el-table-column label="序号" type="index" width="55"></el-table-column>
                <el-table-column  v-for="(item ,index) in logCol.filter(item=>item.thide=='N')" :key="index"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"  
                    :min-width="item.width">
                </el-table-column>         
            </el-table>
        </el-dialog>
       
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog>  
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">{{ $LANG('2052', '正在上传中') }}...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
 
import repWin from '../datamgt/repWin.vue' 
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition, isVeTableMetadataField } from '@/utils/veTableHeaderQuery'
export default {
    name:'mat_query',
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '486895',
            fieldIdseq: '486895',
            fieldLstseq: '1',
            mainColumnKey: 'tabCol',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'refqc',
            generatedFixedColumnKeys: ['rownum', 'index', 'oper'],
        })
    ],
    data () {
        return {
            repWin:false,
            repUrl:'',
            mainRow:{},
            promptWin:false,
            logWin:false,
            pageIndex:1,
            prompt:'',
            input_hold:this.$LANG('1670', '请输入内容')+'...',
            ruleValidate:{},
            selparam:'STKNM',
            txtparam:'',
            pageSize:50,
            footerData:[],
            comboArr:[],
            goPage:'',
            v_stk:'Y',
            qcData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            chkBool:false, //确认权限
            v_loading:false,
            current:1,
            saveFlag:false,
 
            allList:[], //询价单集合
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , 
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            pageList: [50,500,1000],  
            dataCount:0,
            rowSize:50,
            tabCol:[],
            initCol:[],
            vueCol:[],
            columnHiddenOption: {
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: { clickHighlight: true },
            cellStyleOption: {
                headerCellClass: () => 'table-head-cell-class',
                bodyCellClass: () => 'table-body-cell-class1',
                footerCellClass: ({ row, column, rowIndex }) => {
                    return "table-foot-cell-class";
                },
            },
            virtualScrollOption: { enable: false },
            v_headerRow:{},
            headerSortKey:'',
            headerSortOrder:'',
            queryRequestId:0,
            operArr:[],
            oper:'like',
            v_idseq:this.$cookies.get('idseq'),
            v_rowIndex:'',
            notNull:[],
            stfgBool:true,
            v_formurl:'xuper_auth/getFormGroup', 
            v_oth:'N', 
            v_admin:this.$cookies.get('v_admin') , 
            v_random:'',
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            v_key:'',
            btnWin:false,
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            v_commit :true,
            uploadData:{}, //上传数据
            videoFlag:false,
            videoUploadPercent:0,
            imgData:[],
            fileName:'',
            uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
            Accept: "png,jpg,jpeg,gif,tiff,pdf",
            delImg:[],
            t_cond:'',
            logData:[],
            logCol:[],
        }
    },
    components: {
        repWin,
      
        VeColumnConfigDialog,
    },
    computed: {
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        },
        subHeight: function() {
            return (window.innerHeight - 180) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 296) + 'px';
        }, 
        selWidth: function() {
            return (window.innerWidth - 220) + 'px';
        },
    },
    mounted () {
 
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });  
 
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','486895','v_sys_user_priv','').then(res=>{           
            let row =res.result[0]
            this.v_oth =row['ISOTH']
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISEXP==='N'){ // 确认
                    this.chkBool=true
                }
            }
        })    
 
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','422002','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
 
     
    },
 
    created () {
        if (this.v_username){
            this.loadingInstance = this.$veLoading({
                target: document.querySelector("#mat_query_one"),
                name: "wave",
            })
            this.getTabCol() //表列集合
            this.getTabList('')   
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        getFootSum(){
            const qty = this.qcData.reduce((sum, row) => sum + (Number(row.QTY) || 0), 0)
            this.footerData = [{
                rowKey: 0,
                index: this.$LANG('0280', '合计'),
                QTY: qty ? qty.toLocaleString() : '',
      
            }]
        },
        headStyle({column,columnIndex}){
             if (column['property']=='BALOUT'){
                return 'color:red'
             }
        },
        //页号改变
        pageNumberChange(pageIndex) {
            this.pageIndex = pageIndex
            this.changePage(pageIndex)
        },
        pageSizeChange(pageSize) {
            this.pageIndex = 1
            this.pageSize = pageSize
            this.changePage(this.pageIndex)
        },
   
        inputBtn(row,index, key){   
            this.v_key =key     
      
        },
        pdfViewer(path){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl: path},
            });
            window.open(routeUrl.href, '_blank');
        },
        //图片删除，操作数组
        imgDel(idseq,lstseq,path,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此附件吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.delImg.push({IDSEQ:idseq,LSTSEQ:lstseq,FILEPATH:path}) 
                this.imgData.splice(index, 1);    
            }).catch(()=>{})
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        //文件格式验证错误时的钩子
        handleFormatError (file) {
            this.promptWin =true
            this.prompt=this.$LANG('1455', '文件格式错误')+','+file.name+' '+this.$LANG('1431', '是不正确， 请选择图片或PDF格式')
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name+this.$LANG('1561', '文件太大， 不能超出')+'5M'
        },
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            if (res.code=='200'){
                this.imgData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:'IMG',PATH:'/web/web_images/material/'+res.result,HASHVAL:res.hashvalue})                   
            } else{
                this.promptWin =true
                this.prompt =res.result
            }               
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile (res, file) {        
            this.fileName= this.v_username+getDate('year')   
            this.uploadData = {
                code: this.fileName ,
                p_type:'IMG',
                p_path:'/web/web_images/material/',
                p_user:this.v_username
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 

        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
 
   
        //查询附件数据
        qryImgData(idseq){
            this.imgData=[]
            getTabColOrData(this.v_url,'V_mat_img','idseq',idseq,'','').then((res) => {              
                if (res){
                    this.imgData =res.result
                }
            })
        },
   
        //表行记录css
        tableRowClass({row, rowIndex}) {
            if (row.STFG  === 'Y') {
                return 'success-row';
            } else if (row.STFG ==='X') {
                return 'cancel-row';
            }
            return '';
        },
        getRowKey(row){
            return row.IDSEQ
        },
 
        //状态变更
        stfgRec(row,val,index,v_comm){
            let v_cond ='' ,v_chkdttm='',v_chkuser='',v_cfmdttm='',v_cfmuser=''
            if (val =='K') {
                v_cfmdttm =getDate('full')
                v_cfmuser =this.v_usernm
                v_cond =' set stfg=\''+val+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\',chkuser=null,chkdttm=null'
            }else if (val =='Y'){
                v_chkdttm =getDate('full')
                v_chkuser =this.v_usernm
                v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
            }else{
                v_chkuser='',v_chkdttm='',v_cfmuser='',v_cfmdttm=''
                v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\''
            }
            this.$confirm(this.$LANG('1564', '你确定要')+v_comm+this.$LANG('1565', '此单据吗')+'?',this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'TRY_REP',p_cond: v_cond},
                }).then(res=>{      
                    if(res.code =='200')  {  
                        if (val =='X'){
                            this.qcData.splice(index,1)
                        } else{        
                            if (val =='Y'){
                                Object.assign(row,{STFGNM:v_comm ,STFG:val, CHKUSER:v_chkuser,CHKDTTM:v_chkdttm})
                            }else{
                                Object.assign(row,{STFGNM:v_comm ,STFG:val,APPUSER:v_cfmuser,APPDTTM:v_cfmdttm,CHKUSER:v_chkuser,CHKDTTM:v_chkdttm})
                            }
                        }
                    }    
                })
            }).catch(()=>{})
             
        },
 
 
        //状态查询
        buildToolbarCondition(key, value, operator){
            if (!isVeTableMetadataField(this.initCol, key)) return ''
            if (operator === '!=') return ` and ${key} is null `
            return buildVeTableFieldCondition(this.initCol, key, value, operator)
        },
        stfgChange(){
            this.current =1
            let cond_=this.buildToolbarCondition(this.selparam, this.txtparam, this.oper)
            cond_+=buildVeTableHeaderCondition(this.initCol, this.v_headerRow)
 
            this.getTabList(cond_)
        }, 
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert(this.$LANG('1721', '请输入跳至页数'), this.$LANG('1442', '提示'), {
                    confirmButtonText: this.$LANG('1638', '确定'),
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.qcData = this.allList.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.qcData = this.allList          
            }else{
         
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.qcData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
            this.getFootSum()
        },
        seeLog(row){
            this.logData=[]
            this.v_loading =true
            this.logWin =true
            let v_cond =' and wkno=\''+row['STKNO']+'\'  order by okdttm desc '
            console.log(row['STKNO'],row['MATNO'])
            getTabColOrData(this.v_url,'V_OUT_STKLOG','corpid',this.v_corpid,'','','matno',row['MATNO'] ,v_cond).then((res) => {                          
                if (res.code==='200'){
                    this.logData=res.result  
                    this.v_loading =false
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                    this.v_loading =false
                }
            })
        },
        //查询清单 
        getTabList(cond){
            if ( this.v_oth=='Y' ){
                cond =cond + ' and stknm=\'' +this.v_usernm+'\''
            }    
            if (this.v_stk =='Y'){
                cond =cond +' and qty>0'
            }
            const requestId = ++this.queryRequestId
            const requestedSortKey =this.headerSortKey || this.selparam
            const sortKey =isVeTableMetadataField(this.initCol, requestedSortKey) ? requestedSortKey : 'MATNO'
            const sortOrder =this.headerSortKey && this.headerSortOrder === 'asc' ? 'asc' : 'desc'
            getTabColOrData(this.v_url,'V_IC_OUTSTKLOG','','','CORPID',this.v_corpid,'','',cond+' order by '+sortKey+' '+sortOrder).then((res) => {
                if (requestId !== this.queryRequestId) return
                this.allList =res.result 
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    const table = this.$refs.refqc
                    if (table && typeof table.doLayout === 'function') table.doLayout()
    
                }) 
                this.initPage() 
            }).catch(error => {
                if (requestId !== this.queryRequestId) return
 
                this.promptWin=true
                this.prompt=error && error.message ? error.message : this.$LANG('1641', '查询失败')
            })
        },
        rowShow(){
            this.v_headerRow={}
            this.stfgChange()
        },
        sortHeaderColumn(key, edcss){
            if (!isVeTableMetadataField(this.initCol, key)) return
            this.headerSortOrder =this.headerSortKey === key && this.headerSortOrder === 'asc' ? 'desc' : 'asc'
            this.headerSortKey =key
            const direction =this.headerSortOrder === 'asc' ? 1 : -1
            const type =String(edcss || '').toLowerCase()
            this.allList.sort((left, right) => {
                const leftValue =left[key]
                const rightValue =right[key]
                if (leftValue === rightValue) return 0
                if (leftValue === null || leftValue === undefined) return -1 * direction
                if (rightValue === null || rightValue === undefined) return direction
                if (type === 'number') return (Number(leftValue) - Number(rightValue)) * direction
                return String(leftValue).localeCompare(String(rightValue)) * direction
            })
            this.current =1
            this.initPage()
        },
 
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','486895','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                vm.initCol = res.result
                return vm.loadInitialFieldSettings().then(() => {
                    const fieldRows = vm.sortFieldRows(vm.initCol)
                    vm.tabCol = []
                    vm.vueCol = []
                    fieldRows.forEach(item => {
                        const title =vm.$translate.getColTitle(item, vm.$store.state.lang)
                        const headerSortable =item.SORTABLE === 'N' && item.EDCSS !== 'checkbox'
                        vm.tabCol.push({
                            title,
                            key: item.key,
                            align: item.align,
                            width: item.width,
                            thide: item.THIDE,
                            fhide: item.FHIDE,
                            edcss: item.EDCSS,
                            disabled: item.DISABLED,
                            dotnum: item.DOTNUM,
                            sortable: item.SORTABLE,
                        })
                        if (item.THIDE !== 'N') return
                        vm.vueCol.push({
                            field: item.key,
                            key: item.key,
                            title,
                            type: item.EDCSS === 'checkbox' ? 'check' : item.EDCSS,
                            align: item.align,
                            width: Number(item.width) || 120,
                            sortable: false,
                            ellipsis: { showTitle: true },
                            renderHeaderCell: ({column}) => <VeTableQueryHeader
                                title={column.title}
                                edcss={item.EDCSS}
                                value={vm.v_headerRow[item.key]}
                                operator={vm.v_headerRow[`#OPER${item.key}`]}
                                showDateOperator={false}
                                sortable={headerSortable}
                                sortOrder={vm.headerSortKey === item.key ? vm.headerSortOrder : ''}
                                options={String(item.EDCSS || '').toLowerCase() === 'select' ? (vm.comboArr[item.key] || []) : []}
                                on-input={(value) => vm.$set(vm.v_headerRow, item.key, value)}
                                on-operator-change={(value) => vm.$set(vm.v_headerRow, `#OPER${item.key}`, value)}
                                on-title-click={() => {
                                    if (headerSortable) vm.sortHeaderColumn(item.key, item.EDCSS)
                                }}
                                on-query={() => vm.stfgChange()}
                            />,
                            renderBodyCell: ({row}) => {
                               
                                if (item.EDCSS === 'checkbox') {
                                    return <el-checkbox disabled true-label="Y" false-label="N" v-model={row[item.key]} style="width:100%">&nbsp;</el-checkbox>
                                }
                                return <span>{row[item.key]}</span>
                            },
                        })
                    })
                    vm.vueCol.unshift({
                        field: 'index',
                        key: 'rownum',
                        title: vm.$LANG('0310', '序号'),
                        width: 60,
                        align: 'center',
                        fixed: 'left',
                        disableResizing: true,
                        renderHeaderCell: ({column}) => <div><div style="margin-top:3px">{column.title}</div><el-link underline={false} on-click={() => vm.rowShow()} style="font-size:12px;color:#404eff;height:30px"><el-tooltip content={vm.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link></div>,
                        renderBodyCell: ({rowIndex}) => rowIndex + 1,
                    })
                    let v_oper ={
                        field: "oper0",
                        key: "oper",
                        title: this.$LANG('0330', '操作'),
                        width:95,
                        align: "center",
                        fixed:"right",
                        renderBodyCell: ({ row, column, rowIndex }, h) => {
                            return ( 
                                <div>
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  on-click={()=>{this.seeLog(row )}}  underline={false} ><span style="font-size:12px;margin-right:5px"> 查看日志 </span></el-link>    
                                </div>                                
                            )
                        },
                    }
                    this.vueCol.push(v_oper)
                    return res
                })
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','486895','LSTSEQ','2' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.logCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        thide: res.result[k].THIDE,
                        fhide: res.result[k].FHIDE,
                        disabled: res.result[k].DISABLED,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        sortable: res.result[k].SORTABLE,
                    })
                }
            })
         
        },
    }
}
</script>
<style scoped lang="less">
    .item-width  {
        width: 32%;
        height:22px;
    }
    .item-one {
        width: 97%;
        height:88px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
 </style>
 <style lang ="less">
 .table-foot-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #b2d3fa !important;
        font-weight:700 !important;
        padding: 2px !important;
        line-height: 25px !important;
        text-align:left !important;
        height: 15px !important;
   
    }
    .table-head-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #e2e6eb !important;
        font-weight: 700 !important;
        padding: 0 !important;
        padding-top: 4px !important;
        text-align: center !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    .table-body-cell-class1 {
        height: 20px !important;
        padding: 2px !important;
        color: black !important;
        font-size: 12px !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
 </style>
